import React from 'react';
import { Helmet } from 'react-helmet-async';
import { SEO } from '../components/seo/SEO';
import { ServiceSchema, VideoSchema, FAQSchema } from '../components/seo/Schema';
import { Hero } from '../components/sections/Hero';
import { ProblemSection } from '../components/sections/ProblemSection';
import { ResultsSnapshot } from '../components/sections/ResultsSnapshot';
import { HomeEnginePreview } from '../components/sections/HomeEnginePreview';
import { AnimatedEngineSection } from '../components/sections/AnimatedEngineSection';
import { HomeSocialProof } from '../components/sections/HomeSocialProof';
import { HomeQuickQualifier } from '../components/sections/HomeQuickQualifier';
import { HomeWhyHIRE } from '../components/sections/HomeWhyHIRE';
import { HomeTopFAQs } from '../components/sections/HomeTopFAQs';
import { FinalCTA } from '../components/sections/FinalCTA';
import { ClientLogos } from '../components/sections/ClientLogos';
export function Home() {
  return <>
      <SEO title="Stop Chasing Applicants. Get a Recruiting Machine | HIRE" description="We build the system that delivers 20-50 qualified interviews every month for D2D sales teams. No ghosting. No chaos. Just consistent hires." canonical="/" ogTitle="Stop Chasing Applicants. Get a Recruiting Machine" ogDescription="We build the system that delivers 20-50 qualified interviews every month. No ghosting. No chaos. Just consistent hires for your D2D sales team." ogImage="https://uploadthingy.s3.us-west-1.amazonaws.com/vZQb1BRCvwHNhKSytwSdua/Screenshot_2025-11-25_at_12.06.50_AM.png?v=2" keywords="d2d recruiting, door-to-door sales recruiting, sales team recruiting system, d2d sales team growth" data-id="element-1397" />

      {/* Facebook Domain Verification */}
      <Helmet data-id="element-1398">
        <meta name="facebook-domain-verification" content="iw4tkcc3d21rlsd9jd9030phzrmgwz" data-id="element-1399" />
      </Helmet>

      <ServiceSchema name="Door-to-Door Sales Recruiting & Retention System" description="Complete recruiting, retention, and results system for door-to-door and direct sales teams" provider="The HIRE Advantage" areaServed="United States" serviceType="Sales Recruiting & Retention for Door-to-Door Teams" data-id="element-1400" />

      <VideoSchema name="The HIRE Advantage Recruiting System Explained" description="See how our 3-part recruiting, retention, and results system helps door-to-door companies scale their sales teams" thumbnailUrl="https://uploadthingy.s3.us-west-1.amazonaws.com/vZQb1BRCvwHNhKSytwSdua/Screenshot_2025-11-25_at_12.06.50_AM.png?v=2" uploadDate="2025-01-15" contentUrl="https://fast.wistia.com/embed/medias/szxj7n6o11" embedUrl="https://fast.wistia.com/embed/iframe/szxj7n6o11" duration="PT3M45S" data-id="element-1401" />

      <div data-id="element-1402">
        <Hero data-id="element-1403" />
        <ClientLogos data-id="element-1404" />
        <ProblemSection data-id="element-1405" />
        <ResultsSnapshot data-id="element-1406" />
        <AnimatedEngineSection data-id="element-1407" />
        <HomeEnginePreview data-id="element-1408" />
        <HomeSocialProof data-id="element-1409" />
        <HomeQuickQualifier data-id="element-1410" />
        <HomeWhyHIRE data-id="element-1411" />
        <HomeTopFAQs data-id="element-1412" />
        <FinalCTA data-id="element-1413" />
      </div>
    </>;
}